/**
* @description: 酒馆参数设置
* @author: lyr
*/
<template>
    <div class="bar-params-set">
        <!-- 门店列表 -->
        <div class="shop-list-panel" v-show="showIndex == 1">
            <div class="page-title">{{ operational_scene_name }}业务参数设置</div>
            <el-table v-loading="loading" element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }" :data="shop_list">
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column :label="operational_scene_name + '业务参数设置'">
                    <template slot-scope="scope">
                        <span class="text-blue" @click="handleSetClick(scope.row)">设置</span>
                        <span class="text-blue" @click="handleSyncClick(scope.row)">同步</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="total, prev, pager, next, jumper" :page-size="page_size"
                :current-page.sync="shop_page" :total="shop_total" @current-change="getOperationalSceneShopList">
            </el-pagination>
        </div>

        <!-- 同步门店参数设置弹窗 -->
        <div class="sync-shop-wrap ele-hide" ref="sync_shop_wrap">
            <div class="tip">将【{{ shop_name }}】{{ operational_scene_name
            }}业务参数设置{{ single_config_field_name ? '【' + single_config_field_name + '】' : '所有数据' }}同步到其他门店：</div>
            <div class="content">
                <el-checkbox v-model="checkAllShop" @change="handleCheckAllShopChange">全选</el-checkbox>
                <el-checkbox-group v-model="selected_shop_list" @change="handleSelectShopChange">
                    <el-checkbox v-for="item in besides_shop_list" :key="item.shop_id" :label="item.shop_id">{{
                        item.shop_name }}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>

        <!-- 门店运营场景配置 -->
        <div class="operational-config-panel" v-show="showIndex == 2">
            <div class="page-title">{{ operational_scene_name }}业务参数设置</div>
            <div class="row">
                <div class="shop-name">门店名称：{{ shop_name }}</div>
                <el-button @click="backToShopList">返回</el-button>
            </div>
            <el-tabs v-model="active_tab" @tab-click="handleTabClick">
                <el-tab-pane :label="item.name" :name="item.name" v-for="item in operational_config" :key="item.type">
                    <el-table class="config-table" v-loading="loading" element-loading-text="努力加载中，请稍后..."
                        element-loading-background="rgba(0, 0, 0, 0.6)" :header-cell-style="{ 'text-align': 'center' }"
                        :cell-style="{ 'text-align': 'center' }" :data="config_list">
                        <el-table-column type="index" label="序号" width="50"></el-table-column>
                        <el-table-column prop="name" label="设置项"></el-table-column>
                        <el-table-column prop="desc" label="设置说明"></el-table-column>
                        <el-table-column prop="value" label="配置"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <span class="text-blue" @click="openPomplexSetPop(scope.row)"
                                    v-if="scope.row.config_type == 2">设置</span>
                                <el-select :value="scope.row.value" @change="handleSelectChange(scope.row, $event)"
                                    size="small" v-else>
                                    <el-option v-for="option in scope.row.config_params[0].option" :key="option.name"
                                        :label="option.name" :value="option.value">
                                    </el-option>
                                </el-select>
                                <span class="text-blue" @click="onSyncSingleConfig(scope.row)">同步</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>

        <!-- 复杂设置弹窗 -->
        <div class="pomplex-set-pop ele-hide" ref="pomplex_set_pop">
            <el-form label-width="100px">
                <el-form-item v-for="(item, index) in config_params" :key="index" :label="item.name">
                    <!-- 单选框 -->
                    <el-radio-group v-model="item.value" v-if="item.type == 'radio'">
                        <el-radio v-for="option in item.option" :key="option.name" :label="option.value">
                            {{ option.name }}
                        </el-radio>
                    </el-radio-group>
                    <!-- 时间选择器 -->
                    <el-time-picker v-model="item.value" v-if="item.type == 'hour_time'" format="HH:mm"
                        value-format="HH:mm" :placeholder="item.name" popper-class="high-index">
                    </el-time-picker>
                    <!-- 下拉选择框 -->
                    <el-select v-model="item.value" v-if="item.type == 'select'" :placeholder="item.name"
                        popper-class="high-index">
                        <el-option v-for="option in item.option" :key="option.name" :label="option.name"
                            :value="option.value">
                        </el-option>
                    </el-select>
                    <!-- 输入框 -->
                    <el-input v-model="item.value" v-if="item.type == 'text'" :placeholder="item.tips"
                        popper-class="high-index">
                        <template slot="append" v-if="item.unit">{{ item.unit }}</template>
                    </el-input>
                    <!-- 多选框 -->
                    <div class="block" v-if="item.type == 'checkbox'">
                        <el-checkbox v-for="option in item.option" :key="option.name" :label="option.name"
                            v-model="option.checked">
                            {{ option.name }}
                        </el-checkbox>
                    </div>
                    <!-- 文本框 -->
                    <el-input v-model="item.value" v-if="item.type == 'textarea'" type="textarea"
                        :id="`textarea-${index}`" :ref="`textarea-${index}`" :placeholder="item.tips"
                        popper-class="high-index">
                    </el-input>
                    <div class="variable-row" v-if="item.type == 'textarea' && item.params.length > 0">
                        <div class="variable-item" v-for="(child, cindex) in item.params" :key="cindex"
                            @click="addVariableIntoTextarea(index, child)">
                            {{ child.name }}
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
export default {
    name: 'self-service-set',
    data() {
        return {
            showIndex: 1, // 1门店列表  2配置
            operational_scene: '4', // 操作场景
            operational_scene_name: '酒馆', // 操作场景名称
            shop_page: 1, // 门店列表页码
            shop_total: 0, // 门店列表总页数
            page_size: 10,
            shop_list: [], // 门店列表
            all_shop_list: [], // 所有门店列表
            besides_shop_list: [], // 其余所有门店列表
            shop_id: '', // 门店ID
            shop_name: '', // 门店名称
            loading: false, // 加载中
            checkAllShop: false, // 全选
            selected_shop_list: [], // 选中的门店列表

            operational_config: [], // 运营配置
            active_tab: '', // 当前激活的tab
            config_list: [], // 配置列表
            config_params: [], // 复杂设置配置参数
            single_config_field_name: '', // 同步单个配置字段名
        }
    },
    mounted() {
        this.getAllShopList();
        this.getOperationalSceneShopList(1);
    },
    methods: {
        // 获取所有门店列表
        getAllShopList() {
            const _this = this;
            Vue.axios.post('CommunityShop/getOperationalSceneShopList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        'page': 0,
                        'page_size': 0,
                        'operational_scene': _this.operational_scene
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.all_shop_list = res.data.response.result.data;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        // 获取相应场景下的门店列表
        getOperationalSceneShopList(page) {
            const _this = this;
            _this.loading = true;
            _this.shop_page = page;
            Vue.axios.post('CommunityShop/getOperationalSceneShopList', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        'page': page,
                        'page_size': _this.page_size,
                        'operational_scene': _this.operational_scene
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        if (page == 1) {
                            _this.shop_total = Number(res.data.response.result.count)
                        }
                        _this.shop_list = res.data.response.result.data;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        // 点击列表“设置”按钮
        handleSetClick(row) {
            this.shop_id = row.shop_id;
            this.shop_name = row.shop_name;
            this.showIndex = 2;
            this.active_tab = '';
            this.config_list = [];
            this.getOperationalConfig();
        },

        // 返回门店列表
        backToShopList() {
            this.showIndex = 1;
        },

        // 点击列表“同步”按钮
        handleSyncClick(row) {
            const _this = this;
            _this.shop_id = row.shop_id;
            _this.shop_name = row.shop_name;
            _this.single_config_field_name = '';
            _this.besides_shop_list = _this.all_shop_list.filter(item => item.shop_id != row.shop_id);
            _this.selected_shop_list = [];
            _this.checkAllShop = false;

            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: '同步参数设置',
                area: ['600px', '600px'], // 宽高
                content: $(_this.$refs.sync_shop_wrap)
            }, function () {
                if (_this.selected_shop_list.length == 0) {
                    layer.msg('请选择要同步的门店');
                    return;
                }
                _this.syncAllConfigToOtherShops();
            });
        },

        // 同步所有参数到其他门店
        syncAllConfigToOtherShops() {
            const _this = this;
            Vue.axios.post('CommunityShop/syncAllConfigToOtherShops', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": _this.shop_id,
                        "sync_shop_arr": _this.selected_shop_list,
                        "operational_scene": _this.operational_scene
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.closeAll();
                        layer.msg('同步成功');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        // 全选
        handleCheckAllShopChange(val) {
            this.selected_shop_list = val ? this.besides_shop_list.map(item => item.shop_id) : [];
        },

        // 选中门店
        handleSelectShopChange(value) {
            this.checkAllShop = value.length === this.besides_shop_list.length;
        },

        // 获取运营配置
        getOperationalConfig() {
            const _this = this;
            Vue.axios.post('CommunityShop/getShopOperationalSceneConfig', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": _this.shop_id,
                        "operational_scene": _this.operational_scene
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        _this.operational_config = res.data.response.result;
                        if (_this.operational_config.length > 0) {
                            if (_this.active_tab == '') {
                                _this.active_tab = _this.operational_config[0].name;
                                _this.config_list = _this.operational_config[0].data;
                            } else {
                                _this.config_list = _this.operational_config.find(item => item.name == _this.active_tab).data;
                            }
                        }
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        // 切换运营配置tab
        handleTabClick(tab, event) {
            this.active_tab = tab.name;
            this.config_list = this.operational_config.find(item => item.name == this.active_tab).data;
        },

        // 设置配置
        setConfig(config_fields) {
            const _this = this;
            Vue.axios.post('CommunityShop/setShopOperationalSceneConfig', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": _this.shop_id,
                        "config_fields": config_fields
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.closeAll();
                        layer.msg('设置成功');
                        _this.getOperationalConfig();
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },

        // 列表选择框切换选择
        handleSelectChange(row, val) {
            const config_fields = [];
            config_fields.push({
                "field": row.fields[0],
                "value": val
            });
            this.setConfig(config_fields);
        },

        // 打开复杂设置弹窗
        openPomplexSetPop(row) {
            const _this = this;
            _this.config_params = JSON.parse(JSON.stringify(row.config_params));
            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: row.name,
                area: ['520px', '450px'], // 宽高
                content: $(_this.$refs.pomplex_set_pop)
            }, function () {
                _this.config_params.forEach(item => {
                    if (item.type == 'checkbox' && item.option.length > 0) {
                        let value = [];
                        item.option.forEach(child => {
                            if (child.checked) {
                                value.push(child.value);
                            }
                        });
                        _this.$set(item, 'value', value);
                    }
                });
                _this.setConfig(_this.config_params);
            });
        },

        // 添加变量到文本框
        addVariableIntoTextarea(index, child) {
            // 获取当前输入框的值
            const currentValue = this.config_params[index].value || '';

            // 获取input元素
            const refKey = `textarea-${index}`;
            const inputEl = document.getElementById(refKey);
            if (!inputEl) return;

            // 获取当前光标位置
            const startPos = inputEl.selectionStart || 0;
            const endPos = inputEl.selectionEnd || 0;

            // 在光标位置插入变量
            const newValue = currentValue.substring(0, startPos) +
                child.field +
                currentValue.substring(endPos);

            // 更新对应的数据
            this.$set(this.config_params[index], 'value', newValue);
        },

        // 点击列表“同步”单个配置按钮
        onSyncSingleConfig(row) {
            const _this = this;
            _this.single_config_field_name = row.name;
            _this.besides_shop_list = _this.all_shop_list.filter(item => item.shop_id != this.shop_id);
            _this.selected_shop_list = [];
            _this.checkAllShop = false;

            layer.confirm('', {
                skin: 'public-alert-skin',
                type: 1,
                btn: ['确定', '取消'], // 按钮
                title: '同步参数设置',
                area: ['600px', '600px'], // 宽高
                content: $(_this.$refs.sync_shop_wrap)
            }, function () {
                if (_this.selected_shop_list.length == 0) {
                    layer.msg('请选择要同步的门店');
                    return;
                }
                _this.syncSingleConfigToOtherShops(row);
            });
        },

        // 同步单个配置到其他门店
        syncSingleConfigToOtherShops(row) {
            const _this = this;
            Vue.axios.post('CommunityShop/syncSingleConfigToOtherShops', {
                "header": Vue.request_header,
                "request": {
                    "param": {
                        "shop_id": _this.shop_id,
                        "sync_shop_arr": _this.selected_shop_list,
                        "sync_fields": row.fields
                    }
                },
                "comment": ""
            })
                .then(res => {
                    if (res.data.response.result_code == "true") {
                        layer.closeAll();
                        layer.msg('同步成功');
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
        },
    }

}
</script>
<style lang="less" scoped>
.shop-list-panel {
    .page-title {
        text-align: center;
        font-size: 30px;
    }
}

.sync-shop-wrap {
    .tip {
        color: red;
    }

    .content {
        margin-top: 20px;

        .el-checkbox {
            min-width: 200px;
            margin-bottom: 10px;
        }
    }
}

.operational-config-panel {
    .page-title {
        text-align: center;
        font-size: 30px;
    }

    .row {
        display: flex;
        align-items: center;

        .shop-name {
            margin-right: 20px;
            font-size: 18px;
        }
    }

    .config-table {
        .el-select {
            width: 120px;
            margin-right: 10px;
        }
    }
}

.pomplex-set-pop {
    .config-item {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        .name {
            font-size: 15px;
            margin-right: 10px;
        }
    }

    .variable-row {
        margin: 10px 0;
        display: flex;
        align-items: center;

        .variable-item {
            padding: 0 10px;
            border: 1px solid #409eff;
            color: #409eff;
            border-radius: 5px;
            margin-right: 10px;
        }
    }
}
</style>